import React, { FC } from 'react';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import SideBySideTags from './components/Modal/SideBySideTags';
import { TAppState } from './reducers';
import * as modalActions from './actions/modals';
import { TModalName } from './types/modals';
import HtmlSizeWarningModal from './components/Modal/HtmlSizeWarningModal';
import { browserStorage } from './common/browserStorage';

const mapStateToProps = (state: TAppState) => {
    const modals = Object.entries(state.modals);
    const openModal = modals
        .map(([key, value]) => {
            if (value.status) {
                return key as TModalName;
            }
            return null;
        })
        .find((value) => value !== null);
    return {
        openModal,
    };
};

const connector = connect(mapStateToProps);
type TProps = ConnectedProps<typeof connector>;

const Modals: FC<TProps> = ({ openModal }) => {
    const dispatch = useDispatch();

    const closeModal = (modalName: TModalName) => {
        dispatch(
            modalActions.setModal({
                name: modalName,
                location: null,
                status: false,
            })
        );
    };

    switch (openModal) {
        case 'sideBySideTagsModal':
            return (
                <SideBySideTags
                    closeModal={() => closeModal('sideBySideTagsModal')}
                    onSubmit={(hideFutureWarnings) => {
                        browserStorage.setItemWithExpiry(
                            'hideFutureSideBySideTagWarnings',
                            hideFutureWarnings.toString(),
                            { ttl: '4w' }
                        );
                        closeModal('sideBySideTagsModal');
                    }}
                />
            );
        case 'htmlSizeWarningModal':
            return <HtmlSizeWarningModal closeModal={() => closeModal('htmlSizeWarningModal')} />;
        default:
            return null;
    }
};

export default connector(Modals);
